import type { CSSProperties, ReactNode } from 'react'
import { cx } from './utils/cx'

export type SpinnerVariant = 'stamp' | 'blocks' | 'halftone' | 'mailbag'

interface SpinnerProps {
  variant?: SpinnerVariant
  label?: ReactNode
  className?: string
  style?: CSSProperties
}

export function Spinner({ variant = 'stamp', label, className, style }: SpinnerProps) {
  return (
    <div className={cx('st-spinner', className)} style={style} role="status" aria-live="polite">
      <SpinnerVisual variant={variant} />
      {label != null && <span className="st-spinner-label">{label}</span>}
    </div>
  )
}

function SpinnerVisual({ variant }: { variant: SpinnerVariant }) {
  switch (variant) {
    case 'stamp':
      return (
        <div className="st-spinner-stamp" aria-hidden="true">
          <div className="ring" />
          <div className="core">SNAP</div>
        </div>
      )
    case 'blocks':
      return (
        <div className="st-spinner-blocks" aria-hidden="true">
          <div className="blk" />
          <div className="blk" />
          <div className="blk" />
          <div className="blk" />
          <div className="blk" />
          <div className="blk" />
          <div className="blk" />
          <div className="blk" />
        </div>
      )
    case 'halftone':
      return <div className="st-spinner-halftone" aria-hidden="true" />
    case 'mailbag':
      return (
        <div className="st-spinner-mailbag" aria-hidden="true">
          <div className="letter" />
          <div className="bag">
            <div className="flap" />
            <div className="label">SNAP / LOADING</div>
          </div>
        </div>
      )
  }
}
